export default __webpack_public_path__ + "static/media/3_1_hl.649ec732.png";